/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addTagGroupType } from '../fn/tag-group-type/add-tag-group-type';
import { AddTagGroupType$Params } from '../fn/tag-group-type/add-tag-group-type';
import { getTagGroupByTagGroupType } from '../fn/tag-group-type/get-tag-group-by-tag-group-type';
import { GetTagGroupByTagGroupType$Params } from '../fn/tag-group-type/get-tag-group-by-tag-group-type';
import { getTagGroupType } from '../fn/tag-group-type/get-tag-group-type';
import { GetTagGroupType$Params } from '../fn/tag-group-type/get-tag-group-type';
import { searchTagGroupByTagGroupType } from '../fn/tag-group-type/search-tag-group-by-tag-group-type';
import { SearchTagGroupByTagGroupType$Params } from '../fn/tag-group-type/search-tag-group-by-tag-group-type';
import { TagGroupList } from '../models/tag-group-list';
import { TagGroupTypeList } from '../models/tag-group-type-list';
import { updateGroupType } from '../fn/tag-group-type/update-group-type';
import { UpdateGroupType$Params } from '../fn/tag-group-type/update-group-type';


/**
 * All about tag group type feature
 */
@Injectable({ providedIn: 'root' })
export class TagGroupTypeService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTagGroupType()` */
  static readonly GetTagGroupTypePath = '/tag-group-types';

  /**
   * Retrieve a tag group types with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagGroupType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagGroupType$Response(params?: GetTagGroupType$Params, context?: HttpContext): Observable<StrictHttpResponse<TagGroupTypeList>> {
    return getTagGroupType(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a tag group types with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagGroupType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagGroupType(params?: GetTagGroupType$Params, context?: HttpContext): Observable<TagGroupTypeList> {
    return this.getTagGroupType$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagGroupTypeList>): TagGroupTypeList => r.body)
    );
  }

  /** Path part for operation `addTagGroupType()` */
  static readonly AddTagGroupTypePath = '/tag-group-types';

  /**
   * add tag group type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTagGroupType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTagGroupType$Response(params: AddTagGroupType$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addTagGroupType(this.http, this.rootUrl, params, context);
  }

  /**
   * add tag group type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addTagGroupType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTagGroupType(params: AddTagGroupType$Params, context?: HttpContext): Observable<void> {
    return this.addTagGroupType$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateGroupType()` */
  static readonly UpdateGroupTypePath = '/tag-group-types/{uid}';

  /**
   * Update groupType.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGroupType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroupType$Response(params: UpdateGroupType$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateGroupType(this.http, this.rootUrl, params, context);
  }

  /**
   * Update groupType.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGroupType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroupType(params: UpdateGroupType$Params, context?: HttpContext): Observable<void> {
    return this.updateGroupType$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTagGroupByTagGroupType()` */
  static readonly GetTagGroupByTagGroupTypePath = '/tag-group-types/{uid}/tag-groups';

  /**
   * Retrieve a tag group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagGroupByTagGroupType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagGroupByTagGroupType$Response(params: GetTagGroupByTagGroupType$Params, context?: HttpContext): Observable<StrictHttpResponse<TagGroupList>> {
    return getTagGroupByTagGroupType(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a tag group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagGroupByTagGroupType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagGroupByTagGroupType(params: GetTagGroupByTagGroupType$Params, context?: HttpContext): Observable<TagGroupList> {
    return this.getTagGroupByTagGroupType$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagGroupList>): TagGroupList => r.body)
    );
  }

  /** Path part for operation `searchTagGroupByTagGroupType()` */
  static readonly SearchTagGroupByTagGroupTypePath = '/tag-group-types/tag-groups/search';

  /**
   * Search tag group with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTagGroupByTagGroupType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTagGroupByTagGroupType$Response(params: SearchTagGroupByTagGroupType$Params, context?: HttpContext): Observable<StrictHttpResponse<TagGroupList>> {
    return searchTagGroupByTagGroupType(this.http, this.rootUrl, params, context);
  }

  /**
   * Search tag group with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTagGroupByTagGroupType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTagGroupByTagGroupType(params: SearchTagGroupByTagGroupType$Params, context?: HttpContext): Observable<TagGroupList> {
    return this.searchTagGroupByTagGroupType$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagGroupList>): TagGroupList => r.body)
    );
  }

}
